// extracted by mini-css-extract-plugin
export default {"languageSwitcherContainer":"Login_languageSwitcherContainer__nJD54","logoContainer":"Login_logoContainer__VzHxS","loginLabel":"Login_loginLabel__Tzq89"};